<template>
  <v-radio-group
    :disabled="$store.getters.isDisabled"
    :value="value"
    @change="$emit('input', $event)"
    hide-details="auto"
  >
    <v-radio
      v-for="item in options"
      :key="'option-' + item.slug"
      :label="item.title"
      :value="item.slug"
    ></v-radio>
  </v-radio-group>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    options() {
      return this.$store.state.options.room_wall_types;
    },
  },
};
</script>
